import { Component, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { LoadingComponent } from './components/loading/loading.component';
import { KuromojiService } from './services/kuromoji.service';
import { ProcessLoadingService } from './services/loading.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  constructor(
    private kuromojiService: KuromojiService,
    private router: Router,
    private loadingService: ProcessLoadingService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loadingService.showLoading();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loadingService.hideLoading();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    //await this.kuromojiService.init();
  }

  protected readonly title = signal('CarePosiWebapp');
}
